import React from 'react'
import { Modal } from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import SlidingPane from 'react-sliding-pane'
import classNames from 'classnames'
import customLanguageTexts from 'language'
import removeIcon from '@assets/images/v2-dashboard/remove.svg'
import { getTimestampAsFullHumanDate, getPlanName } from '../../../helpers'
import './index.css'

const ModalSubscriptionSuccessDowngrade = () => {
  const settings = useSelector(state => state.settings)
  const apps = useSelector(state => state.apps)
  const dispatch = useDispatch()

  const handleCancel = () => {
    dispatch({
      type: 'settings/CHANGE_SETTING',
      payload: {
        setting: 'visibleModalID',
        value: '',
      },
    })
  }

  const { visibleModalID } = settings
  const modalID = 'subscriptionSuccessDowngrade'
  const visible = modalID === visibleModalID

  return (
    <div>
      {!settings.isMobileXSView ? (
        <Modal
          className="custom__success__modal"
          title={<div>Congratulations!</div>}
          open={visible}
          onCancel={handleCancel}
          footer={false}
          maskClosable={false}
        >
          <div className="p-0">
            <div className="">
              {customLanguageTexts.SUBSCRIPTION_DOWNGRADE_END_OF_TERM_MODAL_DESCRIPTION}{' '}
              {getTimestampAsFullHumanDate(apps.active.downgradesAt)}{' '}
              {apps.active.planDowngradedTo !== undefined ? (
                <span>
                  {' '}
                  to <b>{getPlanName(apps.active.planDowngradedTo, true)}</b>
                </span>
              ) : (
                ''
              )}
            </div>
          </div>
        </Modal>
      ) : (
        <SlidingPane
          isOpen={visible}
          onRequestClose={handleCancel}
          className={classNames('custom__extension__slider', 'successSubcription')}
          width="100%"
          from="bottom"
          title={<div>Congratulations!</div>}
          closeIcon={
            <img
              src={removeIcon}
              className="closeSuccessSub"
              alt="close"
            />
          }
        >
          <div className="p-0">
            <div className="">
              {customLanguageTexts.SUBSCRIPTION_DOWNGRADE_END_OF_TERM_MODAL_DESCRIPTION}{' '}
              {getTimestampAsFullHumanDate(apps.active.downgradesAt)}
            </div>
          </div>
        </SlidingPane>
      )}
    </div>
  )
}

export default ModalSubscriptionSuccessDowngrade
